module.exports = __webpack_public_path__ + "static/media/dashboard-pro-call-en.02b73ef6.webp";